<shared-szczegoly-lokalizacji
        [formularzLokalizacjiUszkodzenia]="formularzLokalizacjiUszkodzenia"
        [opisWspoldzielonychParametrow]="'Podaj wymiary pomieszczenia'"
        [pokazSzerokosc]="true"
        [pokazDlugosc]="true"
        [pokazWysokosc]="true"
        [pokazRokRemontu]="true"
        [czyDataRemontuWymagana]="this.czyDataRemontuWymagana"
></shared-szczegoly-lokalizacji>

<app-step
        description="Co zostało uszkodzone?"
        [nextEnabled]="czyWprowadzoneUszkodzeniaSaPoprawne && formularzLokalizacjiUszkodzenia.valid"
        nextLabel="ZAPISZ"
        (nextStepClicked)="zapiszUszkodzeniazPodformularzy()"
        (previousStepClicked)="this.navigation.back()">

    <div class="o-flex o-flex--grids mt-5">
        <div class="o-flex__item u-flex-5/12@desktop u-flex-1/1@small u-hidden-visually@less-then-wide">
            <shared-selektor-lokalizacja
                    [uszkodzenia]="listaDostepnychUszkodzen"
                    [nazwaLokalizacji]="lokalizacjaUszkodzen.name"
            ></shared-selektor-lokalizacja>
        </div>
        <div class="o-flex__item u-flex-7/12@desktop u-flex-1/1@small align-self-stretch">
            <div class="c-card" style="height: auto; overflow: inherit">
                <shared-uszkodzenia-w-lokalizacji
                        *ngFor="let uszkodzenie of listaDostepnychUszkodzen"
                        [elementUszkodzenia]="uszkodzenie"
                        [formularzLokalizacjiUszkodzenia]="formularzLokalizacjiUszkodzenia"
                        [czyWalidacjaWartosciUszkodzeniaWzgledemWymiarowLokalizacji]="true"
                        [czyBrakObrazka]="true"
                        [czyGrupowac]="uszkodzenie.czyGrupowac"
                        [maksymalnaIloscElementow]="uszkodzenie.maksymalnaIloscElementow"
                        [pokazSzerokosc]="uszkodzenie.atrybuty.pokazSzerokosc"
                        [pokazWysokosc]="uszkodzenie.atrybuty.pokazWysokosc"
                        [pokazWartosc]="uszkodzenie.atrybuty.pokazWartosc"
                ></shared-uszkodzenia-w-lokalizacji>
            </div>
        </div>
    </div>
</app-step>
